(function() {
    angular
        .module('ngmvac')
        .factory('PaymentFactory', PaymentFactory);

    PaymentFactory.$inject = ['$http'];

    function PaymentFactory($http) {
        return {
            validaCupon: validaCupon,
            getPercents : getPercents,
            getValidatedCoupon: getValidatedCoupon,
            getTotal: getTotal,
            storePayment : storePayment,
            isValid : isValid,
            quitCupon : quitCupon,
            datoswebpay : datoswebpay
        }

        function validaCupon(cupon) {
            return $http.post('/valida/cupon', {cupon: cupon});
        }

        function getPercents(){
            return $http.get('/payments/get_percents');
        }

        function getValidatedCoupon() {
            return $http.get('/coupon/validated');
        }

        function getTotal(){
            return $http.get('/payments/get_totals');
        }

        function storePayment(){
            return $http.post('/payment/store_payment');
        }
        function isValid(){
            return $http.get('/payment/isValidAdvancePayment');
        }
        function quitCupon(){
            return $http.get('/coupon/delete');
        }
        function datoswebpay(params){
            return $http.post('/PagarReserva', params)
        }
    }
})();